import React from 'react';
import styles from './HorizCard.module.scss';
import Text from '../text/Text';
import HtmlTag from '../../molecule/htmlTag/HtmlTag';
import formatDate from '../../../app/helpers/formateDate';
import { Link, useNavigate } from 'react-router-dom';
import useIsRtl from '../../../app/helpers/isRtl';
import getCookie from '../../../app/helpers/getCookie';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';
const lineSvg = '/assets/svg/line.svg';
const clockSvg = '/assets/svg/cards/clock.svg';
const defaultImage = '/images/defaultImage';

const HorizCard = ({
  id,
  image,
  date,
  title,
  description,
  type,
  gallery = [],
  isCLickable,
  registerLink,
  isGrid,
}) => {
  const navigate = useNavigate();
  const isEnglish = getCookie('googtrans')?.includes('/ar/en');

  const isRtl = useIsRtl();
  const sanitizedImageUrl = sanitizeAndValidateUrl(image);
  const handleError = (e) => {
    e.target.src = defaultImage;
  };
  const handleNavigate = () => {
    navigate(`/news-and-events/news/${type}-${id}`);
  };
  return (
    <div
      className={`${styles.card} ${isCLickable ? styles['clickable-card'] : ''} ${isRtl ? styles.rtl : ''}`}
      onClick={isCLickable ? handleNavigate : () => {}}
    >
      <div className={styles.imageWrapper}>
        {type === 'events' && date ? (
          <div className={`${styles.tag} ${isRtl ? styles['rtl-tag'] : ''}`}>
            <img src={clockSvg} alt="" />
            <Text
              title={
                new Date(date) < new Date()
                  ? 'common.date_expired'
                  : formatDate(date)
              }
              variant="text-regular-12"
              className={`${styles.eventDate}`}
              style={{ direction: 'ltr' }}
            />
          </div>
        ) : null}
        <img
          src={sanitizedImageUrl || defaultImage}
          alt={title || ''}
          className={styles.image}
          onError={handleError}
          loading="lazy"
          decoding="async"
        />
      </div>

      <div
        className={`${styles.content} ${type === 'events' ? styles['event-content'] : ''}`}
      >
        {type !== 'events' && date ? (
          <Text
            title={formatDate(date)}
            variant="text-regular-16"
            className={`${styles.date} notranslate`}
            style={{ direction: 'ltr' }}
          />
        ) : null}
        {type === 'media' && gallery?.images?.length > 0 ? (
          <div
            className={`${styles.mediaCount} ${isRtl ? styles['mediaCount-rtl'] : ''}`}
          >
            <Text
              title={gallery.images.length}
              variant="text-regular-12"
              className={`${styles.date} notranslate`}
              style={{ direction: 'ltr' }}
            />
            <Text
              title={
                isRtl && !isEnglish
                  ? 'common.photo'
                  : gallery?.images?.length === 1
                    ? 'photo'
                    : 'photos'
              }
              variant="text-regular-12"
              className={styles.date}
            />
          </div>
        ) : null}

        <div
          className={styles['title-container']}
          dir={isRtl && type !== 'news' ? 'rtl' : ''}
        >
          {' '}
          {type === 'events' ? (
            <div
              className={`${styles['tag-header']} ${isRtl ? styles['rtl-tag'] : ''}`}
            >
              <img src={clockSvg} alt="" />
              <Text
                title={
                  new Date(date) < new Date()
                    ? 'common.date_expired'
                    : formatDate(date)
                }
                variant="text-regular-12"
                className={`${styles.eventDate}`}
                style={{ direction: 'ltr' }}
              />
            </div>
          ) : null}
          <div
            className={`${styles['title']} ${type === 'events' || type === 'media' ? styles['event-title'] : ''}`}
          >
            <Text
              title={title}
              variant="text-bold-italic-25"
              color="black"
              maxLines={2}
              className={styles.titleText}
            />
          </div>
          {type !== 'events' ? (
            <div className={`${styles['line-container']}`}>
              <img src={lineSvg} className={styles.line} alt="" />
            </div>
          ) : null}
        </div>

        {type !== 'media' ? (
          <>
            <HtmlTag
              title={description}
              variant="text-regular-12"
              color="black"
              maxLines={3}
              className={styles.description}
            />
            {type === 'news' ? (
              <Link
                to={`/news-and-events/news/${type}-${id}`}
                className={`${styles.readMore} ${isRtl ? styles['flex-end'] : ''}`}
              >
                <Text
                  title="common.read_more"
                  variant="text-bold-italic-16"
                  className={styles.link}
                />
              </Link>
            ) : (
              <a
                href={
                  /^https?:\/\//i.test(registerLink)
                    ? registerLink
                    : `https://${registerLink}`
                }
                target="_blank"
                rel="noopener noreferrer"
                className={`${styles.readMore} ${isRtl ? styles['flex-end'] : ''} ${styles['register-link']}`}
              >
                <Text
                  title="registrationPage.Register"
                  variant="text-bold-italic-16"
                  className={styles.link}
                />
              </a>
            )}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default HorizCard;
